import Background from '../ui/Background';
import ClickableMixin from './mixins/ClickableMixin';
import mixin from '../privates/utils/mixin';
import ContainableMixin from './mixins/ContainableMixin';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';

/**
 * @class Column
 * @summary A `Column` is a component part of a `ColumnStrip`.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.Background
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @queryable
 * @tagname column
 * @viewername wysiwyg.viewer.components.Column
 * @definitionId wysiwyg.viewer.components.Column
 */
class Column extends Background {}

mixin(Column.prototype, HiddenCollapsedMixin.prototype);
mixin(Column.prototype, ClickableMixin.prototype);
mixin(Column.prototype, ContainableMixin.prototype);

export default Column;
